import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiAxios from "helpers/apiAxios";
import { toast } from "react-toastify";

const projectPartnerUrl = "/crm/projects/:project_id/partners";

export const getProjectPartners = createAsyncThunk(
  "ProjectPartner/getProjectPartners",
  async (projectId) => {
    try {
      const response = await apiAxios.get(projectPartnerUrl.replace(":project_id", projectId))
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

export const createProjectPartner = createAsyncThunk(
  "ProjectPartner/createProjectPartner",
  async ({projectId, data}, { rejectWithValue }) => {
    try {
      const response = await apiAxios.post(
        projectPartnerUrl.replace(":project_id", projectId),
        data
      )
      return response.data
    }
    catch(error){
      return rejectWithValue(error.response.data)
    }
  }
)

export const updateProjectPartner = createAsyncThunk(
  "ProjectPartner/updateProjectPartner",
  async ({ projectId, partnerId, data }, { rejectWithValue }) => {
    try {
      const response = await apiAxios.put(`${projectPartnerUrl.replace(":project_id", projectId)}/${partnerId}`, data)
      return response.data
    }
    catch(error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const deleteProjectPartner = createAsyncThunk(
  "ProjectPartner/deleteProjectPartner",
  async ({projectId, partnerId}) => {
    try {
      const response = await apiAxios.delete(`${projectPartnerUrl.replace(":project_id", projectId)}/${partnerId}`);
      return {
        partnerId,
        data: response.data
      };
    } catch (error) {
      throw new Error(error.message)
    }
  }
)

const handlePayload = (state, action, type="none") => {
  const { error, data, message } = action.payload;

  if (error !== undefined) {
    toast.error(error);
    return;
  } 
  else 
  {
    const record = data.attributes
    
    if (record !== null) {
      switch (type) {
        case "create": 
          state.data.unshift(record)
          break;
        case "delete":
          state.data = state.data.filter((item) => item.id !== record.id)
          break;
        default:
        {
          const updatedIndex = state.data.findIndex((item) => item.id === record.id)
          if (updatedIndex !== -1) {
            state.data[updatedIndex] = record
          }
          break;
        }
      }
    }

    if (message !== null) {
      toast.success(message);
    }
  }
};

const isRejectedAction = (action) => (action.type.startsWith("ProjectPartner/")) && action.type.endsWith("/rejected");

const partnerSlice = createSlice({
  name: "crm_project_partner",
  initialState: {
    data: []
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProjectPartners.fulfilled, (state, action) => {
        const data = action.payload;
        state.data = Array.isArray(data) ? data.map(item => item.attributes) : [];
      })
      .addCase(createProjectPartner.fulfilled, (state, action) => {
        handlePayload(state, action, "create")
      })
      .addCase(updateProjectPartner.fulfilled, (state, action) => {
        handlePayload(state, action)
      })
      .addCase(deleteProjectPartner.fulfilled, (state, action) => {
        const { error, partnerId } = action.payload;

        if (error !== undefined) {
          toast.error(error);
        } else {
          state.data = state.data.filter((item) => item.id !== partnerId)
          toast.success(`Record ${partnerId} was successfully deleted.`);
        }
      })
      .addMatcher(
        isRejectedAction,
        (state, action) => {
          state.loading = false;
          toast.error(action.payload?.message || action.payload?.error || action?.error?.message)
        }
      );
  }
})

export const {
  setNestedPage,
  setNestedPageSize,
  setNestedParams,
  resetNestedParams,
  setSortParams,
  setFilterTag,
  resetFilterTag
} = partnerSlice.actions

export default partnerSlice.reducer